import { z } from 'zod';

export const userSiteDtoSchema = z.object({
  userId: z.string().uuid(),
  siteId: z.string().uuid(),
  isPreferred: z.boolean(),
  createdAt: z.string().datetime(),
});

export const assignUserToSiteSchema = z.object({
  siteId: z.string().uuid(),
  isPreferred: z.boolean().optional().default(false),
});

export const setPreferredSiteSchema = z.object({
  siteId: z.string().uuid(),
});

export const myWorkSiteDtoSchema = z.object({
  siteId: z.string().uuid(),
  siteName: z.string(),
  isPreferred: z.boolean(),
  city: z.string().nullable(),
  country: z.string().nullable(),
  /** Phase agrégée du site (SMQ / pilotage). */
  sitePhaseCode: z.string(),
  /** Phase du parcours de l'utilisateur connecté sur ce site (affectation user ↔ site). */
  userPhaseCode: z.string(),
});

export type UserSiteDto = z.infer<typeof userSiteDtoSchema>;
export type AssignUserToSiteInput = z.infer<typeof assignUserToSiteSchema>;
export type SetPreferredSiteInput = z.infer<typeof setPreferredSiteSchema>;
export type MyWorkSiteDto = z.infer<typeof myWorkSiteDtoSchema>;
